import React, { useContext, useRef } from "react";
import ArrowDown from "../../Assets/Images/Arrowdown.svg";
import "./product.css";
import ProductBanner from "../../Components/Product/ProductBanner";
import BenefitSectionPlanPage from "../../Components/BenefitsSectionPlanPage";
import PricingSectionHome from "../../Components/PricingSectionHome/PricingSectionHome";
import HealthServices from "../../Components/HealthServices";
import CapsuleSlider from "../../Components/CapsuleSlider";
import WellnessHero from "../../Components/WellnessHero";
import BenefitsSection from "../../Components/BenefitdSection";
import UpgradeNetwork from "../../Components/UpgradeNetwork";
import FAQs from "../../Components/FAQs";
import FAQsMobile from "../../Components/FAQsIndexaMobile";
import HealthInsuranceHero from "../../Components/HealthInsuranceHero";

import HomeOverlayElement1 from "../../Assets/Images/home-overlay-element-1.png";
import HomeOverlayElement2 from "../../Assets/Images/home-overlay-element-3.png";
import HomeOverlayElement3 from "../../Assets/Images/home-overlay-element-2.png";

import CoverImage from "../../Assets/Images/UniverseIndexProduct-image.png";
import CoverMobileImage from "../../Assets/Images/UniverseIndexProduct-mobile-image.png";
import SliderSection from "../../Components/SliderSection";
import NavBar from "../../Components/NavBar";
import desktopImage from "../../Assets/Images/product-banner-3.png";
import mobileImage from "../../Assets/Images/product-banner-3-mobile.png";
import { useAnimateOnScroll } from "../../Hooks/useAnimationScroll";

import FixedAccountIcon from "../../Assets/Images/fixed-account-icon.png";
import IndexedAccountIcon from "../../Assets/Images/indexed-account-icon.svg";

import BenefitRiderIcon1 from "../../Assets/Images/benefit-rider-blue-icon1.svg";
import BenefitRiderIcon2 from "../../Assets/Images/benefit-rider-icon2.svg";
import BenefitRiderIcon3 from "../../Assets/Images/benefit-rider-icon3.svg";
import BenefitRiderIcon4 from "../../Assets/Images/benefit-rider-blue-icon4.svg";
import BenefitRiderIcon5 from "../../Assets/Images/benefit-rider-icon5.svg";
import BenefitRiderMobileIcon4 from "../../Assets/Images/benefit-rider-blue-icon4.svg";
import BenefitRiderMobileIcon1 from "../../Assets/Images/benefit-rider-blue-icon1.svg";

import BenefitsImage from "../../Assets/Images/account-value-img.png";
import BenefitsIcon1 from "../../Assets/Images/premiums-icon.svg";
import BenefitsIcon2 from "../../Assets/Images/interest-icon.svg";
import BenefitsIcon3 from "../../Assets/Images/deduction-icon.svg";
import BenefitsIcon4 from "../../Assets/Images/other-deduction-icon.svg";
import BenefitsRightArrowIcon from "../../Assets/Images/right-arrow.svg";
import BenefitsleftArrowIcon from "../../Assets/Images/left-arrow.svg";
import AccountValueIcon from "../../Assets/Images/account-value-icon.svg";

import UniversalType1 from "../../Assets/Images/universal-type1.svg";

import BenefitsMobileImage from "../../Assets/Images/account-value-mobile-img.png";

import HomeOverlayMobileElement3 from "../../Assets/Images/universe-overlay-element-mobile-1.png";
import HomeOverlayMobileElement2 from "../../Assets/Images/universe-overlay-element-mobile-2.png";

import { LanguageContext } from "../../Hooks/langugaeContext";
import { TransEn, TransEs } from "../../constants/HomeBannerConst";
import { motion } from "framer-motion";
import { useTranslation } from "../../Hooks/useTranslation"; // Import the hook

const IndexedUniversalLifeInsurance = () => {
  const translations = useTranslation(); // Get translations dynamically
  useAnimateOnScroll();
  // language translation code
  // const { language } = useContext(LanguageContext);
  // const translations = language === "Eng" ? TransEn : TransEs;

  const scrollToRef = useRef(null);
  const scrollToContent = () => {
    scrollToRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const listItems = [
    {
      y: "30%",
      rotate: 3,
      bgColor: "bg-[#F7F6F2]",
      icon: BenefitRiderIcon1,
      mobileIcon: BenefitRiderMobileIcon1,
      heading: translations.indexaBenefits.benefitsOptions.options1_title,
      content: translations.indexaBenefits.benefitsOptions.options1_Desc,
    },
    {
      y: "40%",
      rotate: 4,
      bgColor: "bg-[#D8ECED]",
      icon: BenefitRiderIcon2,
      mobileIcon: BenefitRiderIcon2,
      heading: translations.indexaBenefits.benefitsOptions.options2_title,
      content: translations.indexaBenefits.benefitsOptions.options2_Desc,
    },
    {
      y: "50%",
      rotate: 5,
      bgColor: "bg-[#FFF4D8]",
      icon: BenefitRiderIcon4,
      mobileIcon: BenefitRiderMobileIcon4,
      heading: translations.indexaBenefits.benefitsOptions.options3_title,
      content: translations.indexaBenefits.benefitsOptions.options3_Desc,
    },
    {
      y: "60%",
      rotate: 6,
      bgColor: "bg-[#D8ECED]",
      icon: BenefitRiderIcon5,
      mobileIcon: BenefitRiderIcon5,
      heading: translations.indexaBenefits.benefitsOptions.options4_title,
      content: translations.indexaBenefits.benefitsOptions.options4_Desc,
    },
    {
      y: "70%",
      rotate: 7,
      bgColor: "bg-[#F7F6F2] lg:bg-[#F7F6F2]",
      icon: BenefitRiderIcon3,
      mobileIcon: BenefitRiderIcon3,
      heading: translations.indexaBenefits.benefitsOptions.options5_title,
      content: translations.indexaBenefits.benefitsOptions.options5_Desc,
    },
  ];

  return (
    <>
      <NavBar />
      <section className="home-welcome  IndexedUniversed-banner container-fluid">
        <div className="IndexedUniversed-overlay-bg"></div>
        <div className="home-welcome-overlay-element">
          <div className="absolute w-full h-full z-[4] animate__animated animate__fadeInDown">
            <img
              alt="overlay-element"
              className="home-welcome-overlay-element--one hidden md:block"
              src={HomeOverlayElement2}
            />
            <img
              alt="overlay-element"
              className="home-welcome-overlay-element--one block md:hidden"
              src={HomeOverlayMobileElement3}
            />
          </div>
          <div className="absolute w-full h-full z-[4] animate__animated animate__fadeInUp">
            <img
              alt="overlay-element"
              className="home-welcome-overlay-element--two hidden md:block"
              src={HomeOverlayElement3}
            />
            <img
              alt="overlay-element"
              className="home-welcome-overlay-element--two block md:hidden"
              src={HomeOverlayMobileElement2}
            />
          </div>
          <div className="absolute w-full h-full z-[6] animate__animated animate__fadeInUp">
            <img
              alt="overlay-element"
              className="home-welcome-overlay-element--three "
              src={HomeOverlayElement1}
            />
          </div>
        </div>
        <div className="absolute container z-[6] left-0 right-0">
          <div className="h-full flex items-center max-w-[389px] IndexedUniversed-banner-caption md:pl-0 px-4">
            <div className="relative ">
              <div className="mb-4 text-[14px] md:block hidden extra-para-vs">
                {translations.indexaBannerSubtitle}
              </div>
              <h1 className="md:mb-4 mb-2 md:leading-[1.8rem] text-[1.25rem] leading-[1.5rem] md:text-[1.5rem] font-semibold tracking-[-0.5px]  animated fadeInUp">
                {translations.indexaBannerHeading}
              </h1>
              <p className="mb-4 text-[14px] leading-normal md:text-[14px] worldclstext max-w-[389px] animated fadeInUp extra-para-vs">
                {translations.indexaBannerDescription}
              </p>
              <div className="text-teal-900 px-8 py-2 pl-0 rounded-full text-lg font-semibold md:hidden block">
                <div className="flex space-x-3 text-white items-center">
                  <div
                    onClick={scrollToContent} // Attach scroll handler
                    className="border-radius scrollarrow arrow-border flex items-center justify-center border-2 border-white rounded-full w-[88px] h-[50px] cursor-pointer"
                  >
                    <img
                      src={ArrowDown}
                      alt="Scroll down arrow"
                      className="animate__animated animate__bounce animate__delay-2s animate__repeat-3"
                    />
                  </div>
                  <span className="hidden lg:block text-lg font-medium scrollToSeeMore">
                    {translations.aboutUsBannerButton}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="absolute container z-[6] left-0 right-0 bottom-16 md:block hidden">
          <div className="text-teal-900 px-8 py-2 pl-0 rounded-full text-lg font-semibold">
            <div className="flex space-x-3 text-white items-center">
              <div
                onClick={scrollToContent} // Attach scroll handler
                className="border-radius scrollarrow arrow-border flex items-center justify-center border-2 border-white rounded-full w-[88px] h-[50px] cursor-pointer"
              >
                <img
                  src={ArrowDown}
                  alt="Scroll down arrow"
                  className="animate__animated animate__bounce animate__delay-2s animate__repeat-3"
                />
              </div>
              <span className="hidden lg:block text-lg font-medium scrollToSeeMore">
                {translations.aboutUsBannerButton}
              </span>
            </div>
          </div>
        </div>
      </section>

      <section
        className="indexa-pro py-12 lg:py-32 md:py-[8rem]"
        ref={scrollToRef}
      >
        <div className="container">
          <div className="flex lg:flex-nowrap flex-wrap gap-8">
            <div className="lg:w-[45%] w-full flex items-center animate__animated animate__fadeInLeft">
              <div className="lg:pl-0 px-4">
                <p className="text-sm text-gray-600 mb-1 learnmoreacc  md:hidden block">
                  Universal Products
                </p>
                <h2 className="md:text-[1.8rem] md:leading-[2.8rem] text-[24px] leading-[28px] tracking-tight font-semibold lg:max-w-[300px] how-indexa-title">
                  {translations.title_how_indexa_works}
                </h2>
                <hr class="bordertitle-line hidden lg:block mb-4" />
                <div className="lg:mt-[10rem] mt-4 lg:max-w-[470px]">
                  <p className="mb-4 text-justify font-mobile-14 text-[14px] extra-para-vs">
                    {translations.how_indexa_worksDesc1}
                  </p>

                  <p
                    className="text-justify font-mobile-14 text-[14px] extra-para-vs"
                    dangerouslySetInnerHTML={{
                      __html: translations.how_indexa_worksDesc2,
                    }}
                  ></p>
                </div>
              </div>
            </div>
            <div className="lg:w-[55%] w-full">
              <div className="flex items-center justify-center">
                <div className="max-w-[200px] flex flex-col lg:px-0 px-4 how-indexa-pro-col">
                  <div className="benefits-grid flex items-center justify-between my-20 animate__animated animate__fadeInLeft">
                    <div>
                      <div className="b-icon  mb-4">
                        <img src={BenefitsIcon1} alt="Benefits Icon" />
                      </div>
                      <h3 className="md:text-[1rem] text-[12px] font-semibold mb-2 tracking-tight md:leading-[20px] leading-[14px] extra-para-vs">
                        {translations.premiums_title}
                      </h3>
                      <p className="text-[14px] leading-[22px] tracking-tight hidden lg:block extra-para-vs">
                        {translations.premiums_info}
                      </p>
                    </div>
                    <div>
                      <img
                        className="min-w-[27px] ml-4"
                        src={BenefitsleftArrowIcon}
                        alt="Benefits Icon"
                      />
                    </div>
                  </div>
                  <div className="benefits-grid flex items-center justify-between  my-20 animate__animated animate__fadeInLeft">
                    <div>
                      <div className="b-icon mb-4">
                        <img src={BenefitsIcon2} alt="Benefits Icon" />
                      </div>
                      <h3 className="md:text-[1rem] text-[12px] font-semibold mb-2 tracking-tight md:leading-[20px] leading-[14px] extra-para-vs">
                        {translations.interest_title}
                      </h3>
                    </div>
                    <div>
                      <img
                        className="min-w-[27px] ml-4"
                        src={BenefitsleftArrowIcon}
                        alt="Benefits Icon"
                      />
                    </div>
                  </div>
                </div>
                <div className="mx-4 relative animate__animated animate__zoomIn how-idexa-image">
                  <img className="hidden lg:block" src={BenefitsImage} alt="" />
                  <img
                    className="block lg:hidden"
                    src={BenefitsMobileImage}
                    alt=""
                  />
                  <div
                    className="flex justify-center flex-col lg:min-w-[215px] min-w-[150px] items-center lg:p-5 p-2.5 rounded-full bg-white absolute top-[50%] left-[-100px] account-value-div"
                    style={{ boxShadow: "4px 3px 13.5px rgb(0 0 0 / 12%)" }}
                  >
                    <img
                      className="md:mb-2 mb-1 md:w-[30px] w-[18px]"
                      src={AccountValueIcon}
                      alt=""
                    />
                    <p className="font-semibold lg:text-[18px] text-[12px] lg:leading-[22px] leading-[17px] tracking-tight">
                      {translations.account_value}
                    </p>
                  </div>
                </div>
                <div className="max-w-[200px] flex flex-col how-indexa-pro-col">
                  <div className="benefits-grid flex items-center justify-between my-16 animate__animated animate__fadeInRight">
                    <div>
                      <img
                        className="min-w-[27px] mr-4"
                        src={BenefitsRightArrowIcon}
                        alt="Benefits Icon"
                      />
                    </div>
                    <div>
                      <div className="b-icon mb-4 ">
                        <img src={BenefitsIcon3} alt="Benefits Icon" />
                      </div>
                      <h3 className="md:text-[1rem] text-[12px] font-semibold mb-2 tracking-tight md:leading-[20px] leading-[14px] extra-para-vs">
                        {translations.monthly_deductions_title}
                      </h3>
                      <p className="text-[14px] leading-[22px] tracking-tight hidden lg:block extra-para-vs">
                        {translations.monthly_deductions_info}
                      </p>
                    </div>
                  </div>
                  <div className="benefits-grid flex items-center justify-between my-16 animate__animated animate__fadeInRight">
                    <div>
                      <img
                        className="min-w-[27px] mr-4"
                        src={BenefitsRightArrowIcon}
                        alt="Benefits Icon"
                      />
                    </div>
                    <div>
                      <div className="b-icon mb-4 ">
                        <img src={BenefitsIcon4} alt="Benefits Icon" />
                      </div>
                      <h3 className="md:text-[1rem] text-[12px] font-semibold mb-2 tracking-tight md:leading-[20px] leading-[14px] extra-para-vs">
                        {translations.other_deductions_title}
                      </h3>
                      <p className="text-[14px] leading-[22px] tracking-tight hidden lg:block extra-para-vs">
                        {translations.other_deductions_info}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex pt-[1.5rem] animate__animated animate__fadeInLeft block lg:hidden">
                <div class="px-4">
                  <h3 className="font-semibold mb-1 text-[16px]">Premiums</h3>
                  <p class="text-[14px] leading-[22px] mb-4 pb-4 border-b border-solid border-[#C6C4C4]">
                    (Minus the premium expense charge as shown on the policy
                    schedule.)
                  </p>
                  <h3 className="font-semibold mb-1 text-[16px]">
                    Monthly deductions
                  </h3>
                  <p class="text-[14px] leading-[22px] mb-4 pb-4 border-b border-solid border-[#C6C4C4]">
                    (Including an administrative fee, cost of insurance for the
                    policy, front-eMay include an administrative fee, cost of
                    insurance for the policy, front-end load, charge per $1.000
                    of specified amount, and rider charges.nd load, if any, any
                    riders, and a charge per $1.000 of specified amount.)
                  </p>
                  <h3 className="font-semibold mb-1 text-[16px]">
                    Other deductions
                  </h3>
                  <p class="text-[14px] leading-[22px] mb-4 pb-4">
                    (Including any partial surrenders and partial surrender
                    charges.)
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="indexed-account py-[4rem] lg:py-[12rem] md:py-[8rem] bg-[#F7F6F2]">
        <div className="container">
          <div className="flex lg:flex-nowrap flex-wrap items-center ">
            <div className="lg:w-1/3 w-full animate__animated animate__fadeInLeft lg:pl-0 pl-4">
              <div className="lg:max-w-[282px] md:max-w-[320px] sm:max-w-[200px] indexed-account-header">
                <h2 className="text-[24px] md:text-[40px] md:leading-[44px] leading-[28px] font-bold mb-2 extra-title-heading">
                  {translations.fixed_and_indexed_accounts}
                </h2>
                <hr className="bordertitle-line mb-4"></hr>
              </div>
            </div>
            <div className="lg:w-2/3 w-full">
              <div className="flex lg:mt-0 mt-16 lg:justify-center overflow-x-auto whitespace-nowrap gap-8">
                <div className="lg:w-1/2 px-4 min-w-[230px] whitespace-normal indexed-account-grid">
                  <div className="animate__animated animate__fadeInUp">
                    <div className="flex-none mb-4">
                      <img src={FixedAccountIcon} className=" w-[65px]" />
                    </div>
                    <div className="">
                      <h3 className="md:text-[24px] text-[18px] font-semibold mb-2.5 md:leading-[28px] leading-[22px] tracking-tight extra-title36">
                        {translations.fixed_account_title}
                      </h3>
                      <p className="text-[14px] leading-[22px] mb-4 extra-para-vs">
                        {translations.fixed_account_description}
                      </p>
                      <p className="text-[14px] leading-[22px] extra-para-vs">
                        {translations.fixed_account_benefits}
                        <br />
                        {translations.fixed_account_stable_interest} <br />
                        {translations.fixed_account_lower_risk}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="lg:w-1/2 px-4 min-w-[230px] whitespace-normal indexed-account-grid">
                  <div className="animate__animated animate__fadeInUp">
                    <div className="flex-none mb-4">
                      <img src={IndexedAccountIcon} className=" w-[65px]" />
                    </div>
                    <div className="">
                      <h3 className="md:text-[24px] text-[18px] font-semibold mb-2.5 md:leading-[28px] leading-[22px] tracking-tight extra-title36">
                        {translations.indexed_account_title}
                      </h3>
                      <p className="text-[14px] leading-[22px] mb-4 extra-para-vs">
                        {translations.indexed_account_description}
                      </p>
                      <p className="text-[14px] leading-[22px] extra-para-vs">
                        {translations.indexed_account_benefits}
                        <br /> {translations.indexed_account_higher_growth}
                        <br /> {translations.indexed_account_higher_risk}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        id=""
        className="benefits-section-layout flex py-12 lg:py-32 md:py-[8rem] flex-wrap flex-col-reverse lg:flex-col md:flex-nowrap min-h-[100vh]"
      >
        <div className="container">
          <div className="flex-1 shrink order-last lg:w-[50%] py-[40px] lg:order-first">
            <div className="pb-[10%] md:pb-[15%] lg:pb-[30%] max-w-[528px] hidden lg:block animate__animated animate__fadeInLeft indexa-universal-header">
              <div className="text-sm text-gray-600 mb-1 learnmoreacc">
                {translations.indexed_universal_product}
              </div>
              <div
                className="text-[40px] leading-[44px] tracking-tight extra-title-heading"
                dangerouslySetInnerHTML={{
                  __html: translations.indexed_account_title2,
                }}
              ></div>
            </div>
            <div>
              <div className="flex pb-[4.5rem] ">
                <div className="lg:max-w-[491px] lg:px-0 px-4 indexa-universal-content">
                  <p
                    className="text-[14px] leading-[22px] mb-4 pb-4 md:border-b border-solid border-[#C6C4C4] animate__animated animate__fadeInLeft animate__delay-0.5s extra-para-vs"
                    dangerouslySetInnerHTML={{
                      __html: translations.indexed_account_description2,
                    }}
                  ></p>
                  <p
                    className="text-[14px] leading-[22px] mb-4 pb-4 md:border-b border-solid border-[#C6C4C4] animate__animated animate__fadeInLeft animate__delay-1s extra-para-vs"
                    dangerouslySetInnerHTML={{
                      __html: translations.participation_rate_description,
                    }}
                  ></p>
                  <p
                    className="text-[14px] leading-[22px] mb-4 pb-4 animate__animated animate__fadeInLeft animate__delay-2s extra-para-vs"
                    dangerouslySetInnerHTML={{
                      __html: translations.floor_description,
                    }}
                  ></p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="relative lg:absolute w-[100%] lg:w-[50%] pl-[20px] right-0">
          <div className="pb-[0] px-4 max-w-[528px] block lg:hidden animate__animated animate__fadeInLeft">
            <div className="text-[14px] font-normal mb-2">
              Indexed Universal Product
            </div>
            <div className="text-[24px] leading-[28px] tracking-tight">
              The Indexed Account
              <span className="font-semibold">
                {" "}
                has a Ceiling, a Participation Rate, and a Floor.
              </span>
            </div>
          </div>
          <div className="tab-capsule-img-box flex-1 w-[100%] flex-none !ml-auto ms-[5%] mt-[5%] md:mt-0 order-first lg:order-last">
            <div className="circle-div ml-[0px] lg:ml-0 mb-[0] md:mb-0 max-h-[688px] animate__animated animate__fadeInRight">
              <img
                src={CoverImage}
                width={"100%"}
                className="object-cover hidden md:block"
              />
              <img
                src={CoverMobileImage}
                width={"100%"}
                className="object-cover block md:hidden"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="Improve-protection pb-[6.5rem]">
        <div className="conntainer-fluid px-16 pl-4 pr-0">
          <div className="lg:pr-0 pl-4">
            <p className="text-[14px] text-black mb-1 md:hidden block">
              Universal Products
            </p>
            <h2
              class="md:text-center md:text-[1.8rem] md:leading-[2.8rem] text-[24px] leading-[28px] mb-10 tracking-tight extra-title-heading"
              dangerouslySetInnerHTML={{
                __html: translations.indexaBenefits.improve_protection,
              }}
            ></h2>
          </div>
          <ul className="flex lg:justify-center overflow-auto improve-protection-uline whitespace-nowrap lg:mb-[5rem] lg:pr-0 pl-3">
            {listItems.map((item, index) => (
              <motion.li
                key={index}
                initial={{
                  opacity: 0,
                  transform: `translate(0%, ${item.y}) rotate(${item.rotate}deg)`,
                }}
                whileInView={{
                  opacity: 1,
                  transform: "translate(0%, 0%) rotate(0deg)",
                }}
                transition={{
                  delay: index * 0.2,
                  duration: 0.5,
                  ease: "easeOut",
                }}
                viewport={{ once: true }}
                className="lg:px-2.5 px-1 lg:w-[270px] min-w-[208px] whitespace-normal improve-protection-grid"
              >
                <div
                  className={`${item.bgColor} rounded-full md:px-5 px-3 md:py-24 h-full pt-16 pb-10`}
                >
                  <div className="min-h-[51px] mb-7 flex">
                    <img
                    src={item.icon}
                    className=" hidden lg:block"
                    alt=""
                  />
                  <img
                    src={item.mobileIcon}
                    className="block lg:hidden"
                    alt=""
                  />
                  </div>
                  <h3 class="md:text-[18px] text-[14px] md:leading-[22px] leading:[20px] font-semibold mb-4 text-[#000000] min-h-[68px] ">
                    {item.heading}
                  </h3>
                  <p
                    class="text-[14px] leading-[22px] mb-3 text-[#000000]"
                    dangerouslySetInnerHTML={{
                      __html: item.content || "",
                    }}
                  ></p>
                </div>
              </motion.li>
            ))}
          </ul>
          <div className="flex justify-center items-center hidden lg:flex">
            <h4 className="text-[24px] font-semibold extra-title36">
              {translations.indexaBenefits.discover_more}
            </h4>
            <button class="bg-[#0D4248] hover:bg-[#0D4248] hover:text-[#ffffff] text-white font-bold rounded-full text-sm px-5 text-center mb-0 gotofaqbtn ml-6 extra-btn-font">
              {translations.indexaBenefits.watch_video}
            </button>
          </div>
        </div>
      </section>

      <div className="hidden md:block">
        <FAQs />
      </div>
      <div className="block md:hidden">
        <FAQsMobile bgWhite={false} />
      </div>
      <HealthInsuranceHero />
    </>
  );
};

export default IndexedUniversalLifeInsurance;
